module.exports = __webpack_public_path__ + "img/box-3-ua.090e104c.png";